/**
 * Created by tofael on 9/3/18.
 */
import React, { Component } from 'react';
import { Document, Page } from 'react-pdf';

import PdfNavigator from './pdf-navigatior';

class PdfViewer extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      numPages: null,
      pageNumber: 1,
    };
  }

  onDocumentLoad = ({ numPages }) => {
    this.setState({ numPages });
  };

  onNext = () =>{
    this.setState((prevState)=>{
      const currentPage = prevState.pageNumber;
      const numPages = prevState.numPages;

      if (currentPage<numPages){
        return {pageNumber: currentPage + 1}
      }
    })
  };

  onPrevious = () =>{
    this.setState((prevState)=>{
      const currentPage = prevState.pageNumber;

      if (currentPage > 1){
        return {pageNumber: currentPage - 1}
      }
    })
  };

  render() {
    const { pageNumber, numPages } = this.state;
    const { file } = this.props;
    return (
      <div>
        <PdfNavigator
          pageNumber={pageNumber}
          numPages={numPages}
          onNext={this.onNext}
          onPrevious={this.onPrevious}
        />
        <Document
          file={file}
          onLoadSuccess={this.onDocumentLoad}>
          <Page pageNumber={pageNumber} />
        </Document>
      </div>
    );
  }
}

export default PdfViewer;



// WEBPACK FOOTER //
// ./src/screens/shared/file-upload/preview/pdf-viewer.js